export enum UserEnum {
  name = "name",
  surname = "surname",
  email = "email",
  phoneNumber = "phone",
  role = "role",
  active = "active"
}
